/** Web push in the browser (U52): what the device supports, key conversion, subscription JSON. */

export type PushSupport = 'ok' | 'unsupported' | 'install';

/**
 * Whether this browser can subscribe: needs a service worker, the Push API and notifications.
 * iPhone / iPad Safari only offers push for a home-screen app ("install").
 */
export function pushSupport(env: {
  serviceWorker: boolean;
  pushManager: boolean;
  notification: boolean;
  ios: boolean;
  standalone: boolean;
}): PushSupport {
  if (env.ios && !env.standalone) return 'install';
  return env.serviceWorker && env.pushManager && env.notification ? 'ok' : 'unsupported';
}

/** The VAPID public key (URL-safe base64) as bytes for `pushManager.subscribe`. */
export function keyBytes(base64url: string): Uint8Array<ArrayBuffer> {
  const pad = '='.repeat((4 - (base64url.length % 4)) % 4);
  const b64 = (base64url + pad).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(b64);
  const out = new Uint8Array(new ArrayBuffer(raw.length));
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

/** The body the server expects, from `PushSubscription.toJSON()`; null when incomplete. */
export function subscriptionBody(json: {
  endpoint?: string | undefined;
  keys?: Record<string, string> | undefined;
}): { endpoint: string; keys: { p256dh: string; auth: string } } | null {
  const p256dh = json.keys?.['p256dh'];
  const auth = json.keys?.['auth'];
  if (!json.endpoint || !p256dh || !auth) return null;
  return { endpoint: json.endpoint, keys: { p256dh, auth } };
}
